import { ODEnumRendererStyle } from '@mdpp/od-belt';
import * as changeCase from 'change-case';
import React from 'react';
export var ODEnumTag = function (props) {
    var text = props.text, value = props.value;
    return (React.createElement("div", { className: "enum_tag_" + changeCase.snakeCase(value) },
        React.createElement("span", null, text)));
};
export var ODEnumRenderer = function (props) {
    var value = props.value, enumRendererType = props.enumRendererType, tagStyleMap = props.tagStyleMap, textMap = props.textMap;
    switch (enumRendererType) {
        case ODEnumRendererStyle.Tag:
            return React.createElement(ODEnumTag, { text: textMap[value], value: value });
        case ODEnumRendererStyle.Text:
            return React.createElement("span", { className: "enum_text_" + changeCase.snakeCase(value) }, textMap[value]);
    }
};
//# sourceMappingURL=ODEnumRenderer.js.map